import { GroupMember } from './group-member.model';

/**
 * A class that let's us group addresses or people.  We'll group by complex or "Local Students"
 */
export class GroupMembers {
  members: GroupMember[];
  title: string;

  constructor(title: string) {
      this.title = title;
      this.members = [];
  }
}
